export default __webpack_public_path__ + "static/media/meeting-anonymous-page.81c293f2.svg";